/* istanbul ignore file */
const advFilter = (input) => {
  let map = input.map((a) => (a.toLowerCase() === 'new-merchant' ? 'new_merchant' : a));
  map = map.map((a) => (a.toLowerCase() === 'earn-more-rewards' ? 'industry-bonusing-filter' : a));
  return map;
};

// eslint-disable-next-line complexity
function getMerchantRecosRequestOneData(
  locale, reqid, at, query, pathname, requestParams, campaign, isOnline) {
  let geoCenter;
  if (query.cl) {
    geoCenter = query.cl.split(',');
  } else {
    geoCenter = campaign.defaultLocation.split(',');
  }

  const request = {
    globalRequest: {
      clientIdentifier: 'maps',
      channelIdentifier: '37',
      locale,
      countryCode: isOnline ? 'US' : campaign.countryCd,
      userTimestamp: new Date().toISOString(),
      requestTimestamp: new Date().toISOString(),
      requestIdentifier: reqid,
    },
    merchantRequestParameters: {
      experienceType: 'secure',
      // sortType: query.cat.includes('Sort-By-Distance') ? 'distance' : 'location',
      sortType: requestParams.distanceApi.length > 0 ? 'distance' : 'score',
      requestLocation: {
        geoCenter: {
          latitude: Number.parseFloat(geoCenter[0]),
          longitude: Number.parseFloat(geoCenter[1]),
        },
        incrementalBoxIndicator: 'Y',
      },
      merchantRequestAdditionalParameters: {
        maxEligibleCount: campaign.campaignPageSize,
        campaignIdentifier: campaign.campaignId,
      },
      merchantFilters: [
        {
          merchantIdentifiers: {
            merchantTypeIdentifier: pathname.includes('online') ? 'online' : 'instore',
            smallMerchantIndicator: query && query.cat && query.cat.includes('Shop-Small') ? 'Y' : campaign.shopSmallInd,
            merchantListIdentifiers:
              Array.isArray(campaign.mleListId)
                ? campaign.mleListId.map(Number)
                : [Number(campaign.mleListId)],
            /* istanbul ignore next */
            campaignListTypes: (pathname?.toLowerCase().includes('au') && query?.cat?.includes('ONLIND'))
              ? ['SHOP SMALL SHOP AND DINE']
              : ((pathname?.toLowerCase().includes('ca') && query?.cat?.includes('ONLIND'))
              ? ['GROCERY OFFER ELIGIBLE']
              :  []),
            bgcListIdentifier: requestParams.bonusingCategoriesApi,
            // contactlessPmtIndicator: query.cat.includes('Contact-less-Payments') ? 'Y' : 'N',
            contactlessPmtIndicator: requestParams.contactlessApi.length > 0 ? 'Y' : '',
          },
          merchantRecentActiveFilter: {
            // recentActiveIndicator: query.cat.includes('Places-with-Recent-Transactions') ?
            // 'Y' : 'N',
            recentActiveIndicator: requestParams.recentApi.length > 0 ? 'Y' : '',
          },
          merchantTreatmentFilter: {
            merchantsWithTreatment: campaign.offerIndicator,
          },
          multiSearchIdentifier: {
            // eslint-disable-next-line no-nested-ternary
            searchTypeKey: requestParams.exactSearch ? 'exactname'
              // eslint-disable-next-line no-nested-ternary
              : requestParams.search ? 'keyword' : '',
            partialSearch: 'N',
          },
          merchantCategoriesFilter: requestParams.categoriesApi, // getMerchantCategories(query),
          merchantAdvancedFilters: {
            filterIdentifier: advFilter(requestParams.advancedCategoriesApi),
            // getMerchantAdvancedFilters(query),
          },
        },
      ],
    },
  };

  const merchantFilters = request.merchantRequestParameters.merchantFilters.at(0);
  if (requestParams.distanceApi.length > 0
    && request.merchantRequestParameters && request.merchantRequestParameters.requestLocation) {
    request.merchantRequestParameters.requestLocation.radius = campaign.radius;
    request.merchantRequestParameters.requestLocation.radiusUnit = campaign.distanceUnit;
  }
  if (requestParams.mid) {
    if (merchantFilters.merchantIdentifiers
      && merchantFilters.merchantIdentifiers.encryptedMerchantIdentifier) {
      request.merchantRequestParameters.merchantFilters.at(0)
        .merchantIdentifiers.encryptedMerchantIdentifier = [requestParams.mid];
    }
  }
  if (requestParams.search) {
    if (merchantFilters.multiSearchIdentifier) {
      request.merchantRequestParameters.merchantFilters.at(0)
        .multiSearchIdentifier.searchValue = [decodeURIComponent(requestParams.search)];
    }
  }
  if (at) {
    const userIdentification = {
      cardObjects: [
        {
          accountToken: at,
        },
      ],
    };
    request.userIdentification = userIdentification;
  }

  return request;
}

export default getMerchantRecosRequestOneData;
